var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { FieldDuration } from 'fable/fieldDuration';
import { FlowType, } from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';
import { durationConverter } from 'utils/duration';
import { getSubmitAnalyticsAction } from 'utils/flowEditor/analytics';
import styles from './shared.module.scss';
export class WaitModal extends Component {
    constructor(props) {
        super(props);
        const { node } = props;
        this.state = {
            payload: node.nodeType === AutomationNodeTypes.WAIT
                ? node.payload
                : {
                    delayInSeconds: 3600,
                    matchNodeId: uuid(),
                    nonMatchNodeId: uuid(),
                },
        };
    }
    handleAnalytics() {
        const { node } = this.props;
        const { payload } = this.state;
        const analyticsAction = getSubmitAnalyticsAction(!!node.isAction);
        analyticsAction({
            flowType: FlowType.FLOW_TYPE_AUTOMATION,
            nodeType: AutomationNodeTypes.WAIT,
            settings: {
                delayInMinutes: payload.delayInSeconds / 60,
            },
        });
    }
    saveHandler() {
        setTimeout(() => {
            // Fixes blur triggering after submit in Firefox
            this.saveNode();
        }, 1);
    }
    saveNode() {
        const { payload } = this.state;
        this.handleAnalytics();
        const nodeOptions = Object.assign(Object.assign({}, this.props.node), { nodeType: AutomationNodeTypes.WAIT, isAction: false, isRemovable: true, isEditable: true, payload: Object.assign(Object.assign({}, payload), { delayInSeconds: payload.delayInSeconds || 60 }) });
        this.props.replaceNode(nodeOptions);
        this.closeModal();
    }
    closeModal() {
        this.props.triggerClose();
    }
    getActionWaitTimeRecursive(action, includeThisAction = false) {
        let actionTime = 0;
        if (action.nodeType === AutomationNodeTypes.INIT) {
            return actionTime;
        }
        if (includeThisAction && action.nodeType === AutomationNodeTypes.WAIT) {
            actionTime = action.payload.delayInSeconds;
        }
        const { parentId } = action;
        if (parentId) {
            const parentAction = this.props.nodes[parentId];
            if (parentAction) {
                actionTime += this.getActionWaitTimeRecursive(parentAction, true);
            }
        }
        return actionTime;
    }
    getWaitingTimes(includeThisAction = false) {
        const { node } = this.props;
        const { payload } = this.state;
        const waitingTime = this.getActionWaitTimeRecursive(node, false);
        return durationConverter.toString(waitingTime + (includeThisAction ? payload.delayInSeconds : 0));
    }
    render() {
        var _a;
        const preWaitingTime = this.getWaitingTimes();
        const { payload } = this.state;
        const { node, nodeLabel } = this.props;
        const isChanged = payload.delayInSeconds !== ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.delayInSeconds);
        return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: this.closeModal, className: styles.modalHead }, { children: _jsx("p", { children: "Specify the wait time before re-checking the initial conditions and executing the next actions." }) })), _jsx(ModalBody, { children: _jsxs(Box, Object.assign({ width: "540px" }, { children: [_jsx(FlexBox, { children: _jsx(FieldDuration, { includeDays: true, input: {
                                        name: 'delayInSeconds',
                                        onChange: (value) => {
                                            this.setState({
                                                payload: Object.assign(Object.assign({}, payload), { delayInSeconds: value }),
                                            });
                                        },
                                        value: payload.delayInSeconds,
                                    } }) }), !!preWaitingTime && (_jsxs(Box, Object.assign({ background: "blue.100", borderRadius: true, margin: "300 0 0 0", padding: "300", color: "neutral.900" }, { children: ["You're about to add more wait time to the flow, which will be added to the previous", ' ', _jsx("strong", { children: this.getWaitingTimes() }), ".", _jsx("br", {}), _jsx("br", {}), "The total wait time after this action will be", ' ', _jsx("strong", { children: this.getWaitingTimes(true) }), "."] })))] })) }), _jsx(ModalFoot, { confirmOnClick: this.saveHandler, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: this.closeModal })] })));
    }
}
__decorate([
    boundMethod
], WaitModal.prototype, "saveHandler", null);
__decorate([
    boundMethod
], WaitModal.prototype, "saveNode", null);
__decorate([
    boundMethod
], WaitModal.prototype, "closeModal", null);
